const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.PUBLIC, ApiDataModel.EMPLOYEE, 'password-reset')

export const apiResetPassword = {
	requestResetPasswordEmail: async (email: string): Promise<void> => {
		const obj = { email }
		await apiCommon(`${groupPrefix}/send-email`, {
			method: 'POST',
			body: obj,
		})
	},

	verifyResetPasswordToken: async (token: string): Promise<void> => {
		const obj = { password_reset_token: token }
		await apiCommon(`${groupPrefix}/verify`, {
			method: 'POST',
			body: obj,
		})
	},

	resetPassword: async (token: string, password: string, passwordConfirmation: string): Promise<void> => {
		const obj = resetPasswordModelToJSON({ token, password, passwordConfirmation })
		await apiCommon(`${groupPrefix}`, { method: 'POST', body: obj })
	},
}
